import { TabStyles } from '@tableau/widgets';
import * as React from 'react';
import { cssClass } from '../../../style';
import { FeatureFlags } from '../../../ts/FeatureFlags';
import { DataRoleSubspaceProps } from '../../types/DataRoleSubspaceProps';
import { RadioEditProvider } from '../../utils/RadioEditProvider';
import { DefinitionSubspaceAboutSection } from './about-section/DefinitionSubspaceAboutSection';
import { DefinitionSubspaceValuesSection } from './values-section/DefinitionSubspaceValuesSection';
import {
  FieldConceptIndexingErrorCode,
  FieldConceptIndexingStatusCode
} from '../../../ts/ServerApi/requests/GetFieldConceptIndexingStatus';

const cssPrefix = 'DataRoleDefinitionSubspace';

const containerClass = cssClass(cssPrefix, 'container', {
  boxSizing: 'border-box',
  marginLeft: TabStyles.Spacing.ExtraLargeSpace,
  marginRight: TabStyles.Spacing.ExtraLargeSpace,
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
});

export const DefinitionSubspace = (
  props: DataRoleSubspaceProps & {
    hasEditPermissions: boolean;
    fieldConceptIndexingStatusCode: FieldConceptIndexingStatusCode;
    fieldConceptIndexingErrorCode: FieldConceptIndexingErrorCode;
  })  => {
  const isReadonly = !FeatureFlags.semanticsServiceDataRoleEditingEnabled || !props.hasEditPermissions;

  return <div className={containerClass} data-tb-test-id={'data-role-definition-space-' + props.dataRoleDetailInfo.id}>
    <RadioEditProvider isReadonly={isReadonly}>
      <DefinitionSubspaceAboutSection
        dataTypes={props.dataRoleDetailInfo.dataRole.field_concept.data_types}
        description={props.dataRoleDetailInfo.dataRole.description}
        synonyms={props.dataRoleDetailInfo.dataRole.field_concept.names}
        siteUrls={props.siteUrls}
        luid={props.dataRoleDetailInfo.dataRole.field_concept_key}
      />
      <DefinitionSubspaceValuesSection
        luid={props.dataRoleDetailInfo.dataRole.field_concept_key}
        fieldName={props.dataRoleDetailInfo.dataRole.name}
        dataTypes={props.dataRoleDetailInfo.dataRole.field_concept.data_types}
        valuesList={props.dataRoleDetailInfo.dataRole.value_concepts}
        valueCount={props.dataRoleDetailInfo.dataRole.value_count}
        fieldConceptIndexingStatusCode={props.fieldConceptIndexingStatusCode}
        fieldConceptIndexingErrorCode={props.fieldConceptIndexingErrorCode}
      />
    </RadioEditProvider>
  </div>;
};
